import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { AdminUsersPageInput, UserV2ListResponse, UsersByRolesInput } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { extranetQueryKeys } from '../queryKeys';

/**
 * `GET /v1/users/account/:accountKey` — liste des utilisateurs d'un compte.
 *
 * Requiert la permission `EXTRANET_ADMIN` côté back. Filtre `roles[]?` côté
 * serveur via query string ; le filtre `search` est appliqué côté client par
 * la page Admin (le back ne le supporte pas).
 *
 * Le back livre `data.items: UserV2Output[]` mais pas de pagination explicite
 * (cf. `UsersByRolesInput` du package qui n'a ni `offset` ni `limit`).
 */
export const useUsersList = (input: AdminUsersPageInput) =>
  useQuery({
    queryKey: extranetQueryKeys.users.list(input),
    queryFn: () =>
      getExtranetApi().get<UsersByRolesInput, UserV2ListResponse['data']>(
        `/v1/users/account/${encodeURIComponent(input.accountKey)}`,
        { roles: input.roles?.length ? input.roles : undefined },
      ),
    enabled: Boolean(input.accountKey),
    placeholderData: keepPreviousData,
  });
